/* Shared text styles that more than one part renders (packages/ui/CLAUDE.md
 * section C7). Engine tier: parts import these; the barrel does not export
 * them. Literal class strings so Tailwind sees them. */

/** The one eyebrow: short uppercase category text above or beside a title.
 *  Byte-equal to KPIValue's label, which set the scale first; a test pins the
 *  two together so they cannot drift apart. */
export const EYEBROW =
  "text-dense-2 uppercase tracking-wider text-pb-text-muted font-semibold";
